import {
    Stack,
    Typography,
    TextField,
    Grid,
} from '@mui/material';

interface CloseOperationProps {
    title: string;
    endDate: string;
    endTime: string;
    onEndDateChange: (date: string) => void;
    onEndTimeChange: (time: string) => void;
}

export default function CloseOperation({
    title,
    endDate,
    endTime,
    onEndDateChange,
    onEndTimeChange
}: CloseOperationProps) {

    return (
        <Stack spacing={4}>
            <Stack spacing={2}>
                <Typography variant="h5">
                    {title}
                </Typography>
                <Typography variant="body1">
                    Confirm the official end date and time of the operation.
                </Typography>
            </Stack>

            <Grid container sx={{ gap: 1 }}>
                <Grid size="auto" sx={{ flex: 1 }}>
                    <TextField
                        label="End Date"
                        type="date"
                        value={endDate}
                        onChange={(e) => onEndDateChange(e.target.value)}
                        variant="outlined"
                        size="medium"
                        fullWidth
                        required
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />
                </Grid>
                <Grid size="auto" sx={{ flex: 1 }}>
                    <TextField
                        label="End Time"
                        type="time"
                        value={endTime}
                        onChange={(e) => onEndTimeChange(e.target.value)}
                        variant="outlined"
                        size="medium"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </Stack>
    );
}